export default {
  labels: {
    title: 'Drag here',
    message: 'Drag "n" drop some files here',
    files: 'files',
    download: 'Download',
    confirm: 'Confirm',
  },
}
